var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLemon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5157 2.72091C10.3443 1.3553 7.46331 1.98706 6.08085 4.13198L6.0344 4.20405C5.86159 4.47216 5.94154 4.82789 6.21296 4.99859C8.38437 6.36419 11.2653 5.73243 12.6478 3.58752L12.6942 3.51545C12.8671 3.24734 12.7871 2.89161 12.5157 2.72091Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5407 9.66226C15.3206 7.21247 12.2231 6.14423 9.62566 6.6741C8.76932 6.84878 7.85876 6.65138 7.04129 6.34477C6.45919 6.12643 5.91017 6.14785 5.55808 6.45919C5.20598 6.77053 5.12388 7.30718 5.27936 7.90276C5.49771 8.73914 5.5959 9.65488 5.32568 10.4763C4.50607 12.968 5.23927 16.1269 7.45933 18.5767C9.71804 21.0691 12.8857 22.1317 15.5104 21.5356C16.3181 21.3522 17.179 21.4882 17.9425 21.8068C18.5568 22.0632 19.1086 22.0745 19.4419 21.7797C19.7753 21.485 19.8247 20.9421 19.6345 20.3106C19.3982 19.5259 19.3562 18.6657 19.6299 17.893C20.5192 15.3818 19.7994 12.1547 17.5407 9.66226ZM8.0874 14.2798C8.48306 14.1107 8.94261 14.2904 9.11381 14.6813C9.48747 15.5342 10.8434 17.3779 13.1199 17.7544C13.5451 17.8247 13.832 18.2222 13.7608 18.6423C13.6896 19.0623 13.2872 19.3457 12.862 19.2754C9.88017 18.7822 8.17873 16.4299 7.68099 15.2937C7.50978 14.9029 7.69174 14.4489 8.0874 14.2798Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemon);
export default __webpack_public_path__ + "static/media/lemon.0b02065c22350099aa43af1ddf35cfc9.svg";
export { ForwardRef as ReactComponent };